import React from "react";
import HeaderContainer from "../Header/HeaderContainer";
import {Layout, Space} from "antd";
import BodyContainer from "../BodyContent/BodyContainer";
import MinimalFooterComponent from "components/reusables/MinimalFooter/MinimalFooterComponent";


function TrfSimulatorContainer(){

  return(
    <Layout id="container">
      <Space id="body" direction="vertical" size={35}>
        <HeaderContainer />
        <Layout  style={{padding:'1rem', alignItems:'center'}}>
          <BodyContainer/>
        </Layout>
      </Space>
      <div id="footer">
        <MinimalFooterComponent/>
      </div>
    </Layout>
  )
}

export default TrfSimulatorContainer;
